/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mat-progress-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#0044ad!important}.exception-body[_ngcontent-%COMP%]   .exception-topbar[_ngcontent-%COMP%], .exception-topbar[_ngcontent-%COMP%]{background:linear-gradient(-324deg,#fff 23%,#004aad)!important}"];
export { styles as styles };

